import { useEffect, FunctionComponent } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop: FunctionComponent = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // scroll to the top of the window any time the path changes
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
